export const useCookie = () => {
  const setCookie = ({ name, value, days, seconds }) => {
    let maxAge;
    if (days) {
      maxAge = "; max-age=" + days * 24 * 60 * 60;
    } else if (seconds) {
      maxAge = "; max-age=" + seconds;
    } else {
      maxAge = "";
    }
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      maxAge +
      "; path=/";
  };

  const getCookie = (name) => {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  return {
    setCookie,
	 getCookie
  };
};
